export default {
  tournamentCountry (state) {
    return {
      ...state,
      storeName: 'tournamentCountry'
    }
  }
}
